// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.21-13236(f7d5f00a8d)-C29/09/2026-16:49:20-B29/09/2026-16:56:32' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.21-13236(f7d5f00a8d)-C29/09/2026-16:49:20-B29/09/2026-16:56:32",
  branch: "production",
  latestTag: "8.0.21",
  revCount: "13236",
  shortHash: "f7d5f00a8d",
  longHash: "f7d5f00a8df87d6bb618a4a068706e1549499210",
  dateCommit: "29/09/2026-16:49:20",
  dateBuild: "29/09/2026-16:56:32",
  buildType: "Ansible",
  } ;
